/**
 * Player verification is currently NON-FUNCTIONAL in RecruitLook Events.
 *
 * Every display path (get_player_verification, get_team_roster_verification,
 * get_event_roster_verification, get_event_verification_team_summary,
 * get_my_teams_verification, get_my_verification_action_items) joins
 * public.event_rosters, which is empty because RecruitLook now owns rosters.
 * Those RPCs therefore return nothing — which rendered as "everyone is fine".
 *
 * Because verification gates check-in, an empty panel is a dangerous false
 * negative, so all verification surfaces show an explicit "unavailable" notice
 * instead of an empty list until verification moves to RecruitLook alongside
 * rosters.
 *
 * Flip this to false only once the surfaces read live RecruitLook data.
 */
export const VERIFICATION_UNAVAILABLE = true;

export const VERIFICATION_UNAVAILABLE_TITLE = 'Player verification is temporarily unavailable';

export const VERIFICATION_UNAVAILABLE_BODY =
  'Verification is being moved to RecruitLook, which now owns players and rosters. This panel cannot show accurate statuses right now — an empty list does NOT mean players are verified. Please do not use this screen to decide whether a team may check in.';

export const VERIFICATION_UNAVAILABLE_BODY_SHORT =
  'Verification is being moved to RecruitLook and cannot show accurate statuses right now. An empty list does not mean players are verified.';
